export const SSO_TYPE = {
  FACEBOOK: 1,
  GOOGLE: 2,
  AMAZON: 3,
  GOOGLE_NEW: 4,
  GOOGLE_PLAY_GAME: 5,
  GAME_CENTER: 6,
  SIGN_IN_WITH_APPLE: 7,
  FIREBASE: 8,
  SCOPELY_IDENTITY: 9,
  GOOGLE_SIGN_IN: 10,
} as const;
